import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

document.addEventListener("DOMContentLoaded", () => {

  // ─── Hero — entrance on page load ──────────────────────────────────────────
  // Not scroll-triggered (unlike .js-reveal below): the hero is already in
  // view the instant the page loads, so it gets its own GSAP timeline that
  // just plays on load — frame first, then two simultaneous groups (headline
  // + ticker + subhead + CTA together, then columns + stats together) so the
  // whole thing settles quickly instead of stepping through every element.
  const heroFrame = document.querySelector(".aiw-hero__frame");
  if (heroFrame && !prefersReducedMotion) {
    gsap.timeline({ defaults: { ease: "power2.out" } })
      .fromTo(heroFrame, { opacity: 0, scale: .97 }, { opacity: 1, scale: 1, duration: .7 })
      .addLabel("content", "-=0.3")
      .fromTo(".aiw-hero__line", { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: .6, stagger: .1 }, "content")
      .fromTo(".aiw-ticker__item", { opacity: 0 }, { opacity: 1, duration: .5, stagger: .03 }, "content")
      .fromTo(".aiw-hero__subhead", { opacity: 0, y: 14 }, { opacity: 1, y: 0, duration: .6 }, "content")
      .fromTo(".aiw-hero__cta", { opacity: 0, y: 14 }, { opacity: 1, y: 0, duration: .6 }, "content")
      .addLabel("secondary", "content+=0.3")
      .fromTo(".aiw-hero__col", { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: .6, stagger: .1 }, "secondary")
      .fromTo(".aiw-hero__stats", { opacity: 0 }, { opacity: 1, duration: .5 }, "secondary");
  }

  // ─── Scroll reveal — fade + rise, once, for anything marked .js-reveal ────
  const revealTargets = gsap.utils.toArray(".js-reveal");
  if (revealTargets.length) {
    if (prefersReducedMotion) {
      gsap.set(revealTargets, { opacity: 1, y: 0 });
    } else {
      revealTargets.forEach((el) => {
        gsap.fromTo(
          el,
          { opacity: 0, y: 28 },
          {
            opacity: 1,
            y: 0,
            duration: .6,
            ease: "power2.out",
            scrollTrigger: {
              trigger: el,
              start: "top 88%",
              once: true,
            },
          }
        );
      });
    }
  }

  // Post thumbnails (and web fonts) finish loading after DOMContentLoaded and
  // shift page height — every .js-reveal trigger position computed above
  // was measured against the pre-images layout, so it silently drifts (a
  // reveal that never fires) unless positions are recalculated once the
  // page has settled.
  window.addEventListener("load", () => ScrollTrigger.refresh());
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => ScrollTrigger.refresh());
  }

});
